import * as React from "react";
import { useState } from "react";

import { Button } from "@arctheme-components/elements/Button/Button";
import { TextField } from "@src/stories/elements/TextField/TextField";

export const NewsletterForm = ({ settings, isSuccess, setIsSuccess, centered = false, sectionId }) => {
    const [firstName, setFirstName] = useState("");
    const [email, setEmail] = useState("");
    
    const handleFirstNameChange = (event) => {
        setFirstName(event.target.value);
    };

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const alignmentClass = centered ? 'text-center' : `text-${settings.content_alignment}`;
    
    // Input styling based on border style
    const inputClasses = settings.input_border_style === "bottom" ? 
        "rounded-none px-0 my-2" : 
        "border rounded px-4 my-2";
    
    // Form layout classes - use different layout when centered
    const formLayoutClasses = centered ? 
        "flex-col items-center" :
        (settings.form_layout === "row" ? "md:flex-row" : "flex-col");

    // Container width classes - for centered layout, make inputs wider and button narrower
    const inputContainerClasses = centered ? 
        "basis-full w-full max-w-md" : 
        "basis-full w-full";
        
    const buttonContainerClasses = centered ? 
        "basis-full w-full max-w-[200px] mt-4" : 
        "basis-full lg:basis-1/3";

    return (
        <div className={`newsletter-signup__form w-full ${alignmentClass}`}>

            <form method="post" action={`/contact#${sectionId}`} className="w-full">
                <input type="hidden" name="form_type" value="customer" />
                <input type="hidden" name="utf8" value="✓" />
                <input type="hidden" name="contact[tags]" value="newsletter" />

                {isSuccess && (typeof window !== "undefined" && window.location.hash === `#${sectionId}`) && (
                    <p className="b3--bold my-4 text-rhv-green max-lg:text-center">
                        You have been successfully added to our newsletter.
                    </p>
                )}

                <div className={`flex w-full flex-col ${formLayoutClasses} gap-4`}>
                    <div className={inputContainerClasses}>
                        <div className={`flex flex-col ${formLayoutClasses} gap-x-6 gap-y-2`}>
                            <div className="flex-1">
                                <TextField
                                    type="floating-input" 
                                    id="firstName" 
                                    label={"First Name"}
                                    name="contact[first_name]"
                                    placeholder={settings.first_name_placeholder || "Enter Your First Name"} 
                                    value={firstName}
                                    onChange={handleFirstNameChange}
                                    className={inputClasses}
                                />
                            </div>

                            <div className="flex-1 relative">
                                <TextField 
                                    type="floating-input" 
                                    id="email" 
                                    label={"Your Email"}
                                    name="contact[email]"
                                    placeholder={settings.email_placeholder || "Enter Your Email"} 
                                    value={email}
                                    onChange={handleEmailChange}
                                    className={inputClasses}
                                />

                                <Button
                                    type="submit"
                                    label={settings.button_text || "Subscribe"}
                                    className="newsletter-signup__subscribe-button"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default NewsletterForm;